var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0957 0.228027C5.53606 -0.26068 6.2909 0.0884644 6.29102 0.778809V9.44482C6.29078 10.135 5.53603 10.4842 5.0957 9.99561L2.7959 7.44287H0.699219C0.314842 7.44287 0.000146684 7.09403 0 6.66748V3.56396C3.6182e-05 3.13732 0.314774 2.78857 0.699219 2.78857H2.7959L5.0957 0.228027ZM7.34082 1.25342C7.34086 0.931327 7.67153 0.701254 7.97559 0.818848C9.75267 1.47851 11.0107 3.15051 11.0107 5.11377C11.0107 7.07704 9.75267 8.74901 7.97559 9.40869C7.67151 9.52118 7.34082 9.29624 7.34082 8.97412V8.87158C7.34098 8.67744 7.46665 8.50855 7.65527 8.43701C9.00789 7.91036 9.96191 6.61701 9.96191 5.11377C9.96188 3.61056 9.00787 2.31716 7.65527 1.79053C7.47187 1.71896 7.34092 1.55015 7.34082 1.35596V1.25342ZM7.34082 3.05322C8.11672 3.43158 8.65134 4.20879 8.65137 5.11377C8.65137 6.01878 8.11674 6.79618 7.34082 7.16943V3.05322Z",
    fill: "#BABBBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.1cfe13e8f1e1188b7a71e7b4200a61b8.svg";
export { ForwardRef as ReactComponent };